import {
  NeedInitialConfiguration,
  SuiteInitialConfiguration,
} from "../../Model/InitialConfiguration";
export enum EFetchInitialConfigAction {
  FETCH_INITIAL_CONFIG_PENDING = "FETCH_INITIAL_CONFIG_PENDING",
  FETCH_INITIAL_CONFIG_SUCCESS = "FETCH_INITIAL_CONFIG_SUCCESS",
  FETCH_INITIAL_CONFIG_ERROR = "FETCH_INITIAL_CONFIG_ERROR",
}

export type FetchInitialConfigAction = {
  type: EFetchInitialConfigAction;
  needInitialConfiguration?: NeedInitialConfiguration;
  suite?: SuiteInitialConfiguration;
  error?: any;
};

export function fetchIsInitialConfigPending(): FetchInitialConfigAction {
  return {
    type: EFetchInitialConfigAction.FETCH_INITIAL_CONFIG_PENDING,
  };
}

export function fetchIsInitialConfigSuccess(data: {
  needInitialConfiguration: NeedInitialConfiguration;
  suite: SuiteInitialConfiguration;
}): FetchInitialConfigAction {
  return {
    type: EFetchInitialConfigAction.FETCH_INITIAL_CONFIG_SUCCESS,
    needInitialConfiguration: data.needInitialConfiguration,
    suite: data.suite,
  };
}

export function fetchIsInitialConfigError(error: any): FetchInitialConfigAction {
  return {
    type: EFetchInitialConfigAction.FETCH_INITIAL_CONFIG_ERROR,
    error: error,
  };
}
